import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core'
import { NgbActiveOffcanvas, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { SmartquoteFavouriteService } from 'src/app/core/services/smartquote/smartquote-favourite.service'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { Observable, tap } from 'rxjs'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { SmartQuoteFavourite } from 'src/app/shared/interfaces/smartquote-favourite/smartquote-favourite.interface'
import { SmartQuoteFavouriteFilter } from 'src/app/shared/interfaces/smartquote-favourite/smartquote-favourite-filter.interface'
import { AsyncPipe, CurrencyPipe } from '@angular/common'
import { ListSelectorComponent } from '../../list-selector/list-selector/list-selector.component'
import { ListOptionDirective } from '../../list-selector/list-selector/list-option.directive'
import { WolseleyProductService } from 'src/app/core/services/wolseley-product.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { CalloutComponent } from '../../callout/callout/callout.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { RouterModule } from '@angular/router'
import { NgxPermissionsModule } from 'ngx-permissions'

@Component({
    selector: 'sf-smartquote-favourite-product-search-pullout',
    imports: [
        FontAwesomeModule,
        RouterModule,
        NgbPaginationModule,
        NgSelectModule,
        NgxPermissionsModule,
        ListSelectorComponent,
        ListOptionDirective,
        ButtonComponent,
        CalloutComponent,
        AsyncPipe,
        CurrencyPipe,
    ],
    templateUrl: './smartquote-favourite-product-search-pullout.component.html',
    styleUrl: './smartquote-favourite-product-search-pullout.component.scss',
})
export class SmartquoteFavouriteProductSearchPulloutComponent implements OnInit {
    activeOffcanvas: NgbActiveOffcanvas = inject(NgbActiveOffcanvas)
    private smartQuoteFavouriteService = inject(SmartquoteFavouriteService)
    private wolseleyProductService = inject(WolseleyProductService)

    productsSearchedHasImages = false
    showImages = false
    includeTerms = false

    favouritesFilter: SmartQuoteFavouriteFilter = {
        pageNumber: 1,
        pageSize: 10,
    }
    favourites$!: Observable<PaginatedList<SmartQuoteFavourite>>

    selectedFavourite: SmartQuoteFavourite | null = null

    @Output() partSelected = new EventEmitter<SmartQuoteFavourite>()

    ngOnInit() {
        this.loadFavourites()
    }

    loadFavourites() {
        this.favourites$ = this.smartQuoteFavouriteService.getFavourites(this.favouritesFilter).pipe(
            tap((res) => {
                this.productsSearchedHasImages = res.items.some((item) => item.imageUrl)
            })
        )
    }

    onPageChange(pageNumber: number) {
        this.includeTerms = !this.includeTerms
        this.favouritesFilter = { ...this.favouritesFilter, pageNumber, includeTerms: this.includeTerms }
        this.loadFavourites()
    }

    onSelectFavourite(favourite: SmartQuoteFavourite) {
        this.selectedFavourite = favourite
    }

    confirmPart(): void {
        this.partSelected.emit(this.selectedFavourite!)
        this.activeOffcanvas.close()
    }

    onIncludeTermsChanged(): void {
        this.includeTerms = !this.includeTerms
        this.favouritesFilter = { ...this.favouritesFilter, includeTerms: this.includeTerms }
        this.loadFavourites()
    }

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }

    close(): void {
        this.activeOffcanvas.close()
    }
}
